<template>
  <div class="mt-8 mx-3">
    <div>
      <v-data-table
        :headers="headers"
        :items="receivedMembers.members"
        :items-per-page="10"
        hide-default-footer
        ><template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title
              >Group contacts[{{
                receivedMembers.totalRecords
              }}]</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn
              class="primary white--text lowercase-text"
              plain
              @click="dialogs.create = true"
            >
              Add member
            </v-btn>
          </v-toolbar> </template
        ><template v-slot:[`item.createdAt`]="{ item }">
          {{ item.createdAt | niceDate }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <MemberTableMenu :member="item" :group="group" /> </template
      ></v-data-table>
    </div>
    <div class="text-center mt-1">
      <PaginationMembers
        store="members"
        collection="members"
        action="fetchMembers"
        :group="group"
      />
    </div>
    <DialogAdd
      @close="dialogs.create = false"
      v-if="dialogs.create"
      :group="group"
    />
  </div>
</template>

<script>
import { format } from "date-fns";
import DialogAdd from "./Dialogs/MemberAdd";
import PaginationMembers from "@/components/shared/PaginateMembers";
import MemberTableMenu from "./menu/MemberTableMenu";
export default {
  props: ["group"],
  components: { DialogAdd, PaginationMembers, MemberTableMenu },
  data() {
    return {
      dialogs: {
        create: false,
      },
      headers: [
        {
          text: "Name",
          align: "start",
          value: "name",
        },
        { text: "Phone", value: "phone" },
        { text: "Created At", value: "createdAt" },
        { text: "Actions", value: "actions" },
      ],
      page: 1,
    };
  },
  created() {
    this.$store.dispatch("members/fetchMembers", {
      id: this.group._id,
      pageNumber: 1,
    });
  },
  computed: {
    receivedMembers() {
      return this.$store.getters["members/members"];
    },
  },
  filters: {
    niceDate(value) {
      return format(new Date(value), "yyyy-MM-dd h:mm a");
    },
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none;
}
.row-pointer {
  cursor: pointer;
  color: #2c5282;
}
.custom-card {
  /* Add your additional border radius values */
  border-radius: 10px;
}
</style>
